<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col sm="10" md="6" lg="4">
          <b-card-group>
            <b-card-img 
              src="/img/brand/TRANSPLAN.svg" 
              class="mb-4"
            />
            <b-card 
              no-body 
              class="p-4"
            >
              <b-card-body>
                <b-form>
                  <h1>Inloggen</h1>
                  <b-card 
                    v-if="result == 200" 
                    bg-variant="success"
                  >
                    <span v-html="result" /> Aanmelden gelukt!
                  </b-card>
                  <b-card 
                    v-if="result > 200" 
                    bg-variant="danger"
                  >
                    <span v-html="result" /> Aanmelden mislukt!
                  </b-card>

                  <p class="text-muted">
                    Aanmelden met de accountgegevens.
                  </p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="username"
                      type="text"
                      autofocus
                      class="form-control"
                      placeholder="Gebruikersnaam"
                      autocomplete="username email"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="password"
                      type="password"
                      class="form-control"
                      placeholder="Wachtwoord"
                      autocomplete="current-password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        :disabled="processing"
                        variant="primary"
                        type="sumbit"
                        class="px-4"
                        @click="onSubmit()"
                      >
                        Aanmelden
                      </b-button>
                    </b-col>
                    <b-col 
                      cols="6" 
                      class="text-right"
                    >
                      <b-button 
                        variant="link" 
                        class="px-0"
                      >
                        Wachtwoord?
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data: function() {
    return {
      username: "",
      password: '',
      processing: false,
      result: null
    };
  },
  methods: {
    onSubmit() {
      this.processing = true;
      this.result = null;
      var formData = {
        username: this.username,
        password: this.password
      };

      var vm = this;
      this.$http
        .get("/authenticate", {
          auth: formData
        })
        .then(function(response) {
          vm.result = response.status;
          // Token is now in httpOnly cookie — browser handles it
          vm.$store.commit("setUserObject", { username: formData.username, exp: response.data.exp, roles: response.data.roles, advies: response.data.advies });
          vm.$store.dispatch('relaties/load');
          vm.$store.dispatch('relaties/connectSse');
          vm.$router.replace({ name: "Dashboard" });
        })
        .catch(function(error) {
          console.log('error',error.response.data.error);
          vm.result = error.response.status;
          vm.processing = false;
        });
    }
  }
};
</script>
